import { render, staticRenderFns } from "./SystemNotificationBar.vue?vue&type=template&id=72be924e&scoped=true"
import script from "./SystemNotificationBar.vue?vue&type=script&lang=ts"
export * from "./SystemNotificationBar.vue?vue&type=script&lang=ts"
import style0 from "./SystemNotificationBar.vue?vue&type=style&index=0&id=72be924e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be924e",
  null
  
)

export default component.exports